import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=46cf4192&scoped=true&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"
import style0 from "./notice.vue?vue&type=style&index=0&id=46cf4192&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cf4192",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\hongyou\\background_ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46cf4192')) {
      api.createRecord('46cf4192', component.options)
    } else {
      api.reload('46cf4192', component.options)
    }
    module.hot.accept("./notice.vue?vue&type=template&id=46cf4192&scoped=true&", function () {
      api.rerender('46cf4192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MsgPop/notice.vue"
export default component.exports